import React from "react";
import "../documentation.css";
import { TodoIcon } from "../../assets/Icons";
import CandImage from "../Components/CandImage";
import Initials from "../Components/Initials";

const IpnDocuments = ({
  candidates,
  getReadingListPdf,
  downloadRef,
  images,
  passImage,
  handleOverlay
}) => {
  const handleDownloadReadingList = candidate => {
    getReadingListPdf(
      candidate.candidateRef,
      candidate.firstName,
      candidate.lastName
    );
  };

  const hasInduction = candidate =>
    candidate &&
    candidate.nonReadingListDocs &&
    candidate.nonReadingListDocs.YIPN ? (
      <div className="tooltip">
        <button
          onClick={() => handleDownloadReadingList(candidate)}
          style={{
            fontSize: "14px",
            width: "100%",
            backgroundColor: "white",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #2196f3"
          }}
        >
          Download
        </button>
      </div>
    ) : (
      <div className="tw-w-full tw-flex tw-justify-center">
        <TodoIcon />
      </div>
    );

  return (
    <div>
      <div className="tw-rounded-md tw-overflow-x-auto ">
        <div className="tw-align-middle tw-rounded-md tw-inline-block tw-min-w-full">
          <div className="tw-shadow tw-rounded-md tw-overflow-hidden tw-border-b tw-border-gray-200 ">
            <table className="tw-min-w-full tw-border-2 tw-border-gray-500 tw-rounded-md tw-mb-8 tw-divide-y tw-divide-gray-200">
              <thead className="tw-bg-gray-50 tw-rounded-md tw-border-2 tw-border-gray-500 ">
                <tr>
                  <th
                    scope="tw-col"
                    style={{ width: "12%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Worker
                  </th>

                  <th
                    scope="col"
                    style={{ width: "11%" }}
                    className="tw-py-4 tw-border-2 tw-rounded-md tw-border-gray-500 tw-text-left tw-text-md tw-font-medium tw-text-gray-500 tw-text-center tw-tracking-wider"
                  >
                    Site Induction
                  </th>
                </tr>
              </thead>
              <tbody className="tw-bg-white tw-divide-y tw-divide-gray-200">
                {candidates.map((c, i) => (
                  <tr className="reading-list__rows" key={i * 100}>
                    <td className="tw-text-sm">
                      <div className="tw-flex lg:tw-flex-row tw-flex-col tw-w-full lg:tw-items-center md:tw-text-left tw-text-center">
                        {images && images[c.candidateRef] ? (
                          <CandImage
                            handleOverlay={handleOverlay}
                            passImage={passImage}
                            image={images[c.candidateRef]}
                            firstName={c.firstName}
                          />
                        ) : (
                          <Initials
                            firstName={c.firstName}
                            lastName={c.lastName}
                          />
                        )}
                        <p className="tw-font-bold tw-font-lg lg:tw-pl-0 tw-pl-1">
                          {c.firstName} {c.lastName}
                        </p>
                      </div>
                    </td>

                    <td className="tw-p-2"> {hasInduction(c)} </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <a className="d-none" ref={downloadRef}></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IpnDocuments;
